import {
    PermissionEntityType,
    PermissionResourceType
} from "../../../../models";

import { EntityJson } from "@cedar-policy/cedar-wasm/web";
import { EntityResolver } from "./EntityResolver";

type ResourceEntity = {
    id: string;
    createdBy?: string | null;
    propertyId?: string | null;
};

export class ResourceEntityResolver<T extends ResourceEntity> implements EntityResolver {
    constructor(
        private readonly getById: (id: string) => Promise<T>
    ) { }

    public async resolveEntity(
        entityType: PermissionEntityType | PermissionResourceType,
        entityId: string
    ): Promise<EntityJson> {
        const resource: T = await this.getById(entityId);
        return {
            uid: {
                id: resource.id,
                type: entityType,
            },
            attrs: {
                ...(resource.createdBy ? {
                    createdBy: {
                        __entity: {
                            id: resource.createdBy,
                            type: PermissionEntityType.USER
                        }
                    }
                } : {}),
            },
            parents: [
                ...(resource.propertyId ? [{
                    __entity: {
                        id: resource.propertyId,
                        type: PermissionResourceType.PROPERTY
                    }
                }] : [])
            ]
        };
    }
}
